// extracted by mini-css-extract-plugin
module.exports = {"vGray6":"#e4e6ec","desc":"ReportAbusePostForm_desc__1o-Dy"};